export type LatLngTuple = [number, number];
export type LatLngBoundsLiteral = [LatLngTuple, LatLngTuple];

const KM_PER_DEG_LAT = 111;

/**
 * Expand a bounding box defined by `coords` by `km` kilometers in every
 * direction. Returns null when `coords` is empty.
 *
 * Why: deg-per-km varies with latitude. Using a flat 0.45° (≈ 50 km) for both
 * axes overshoots longitudinally near the equator and undershoots near the
 * poles. We scale lng by cos(midLat).
 */
export function expandBoundsByKm(coords: LatLngTuple[], km: number): LatLngBoundsLiteral | null {
    if (coords.length === 0) return null;

    let minLat = Infinity;
    let maxLat = -Infinity;
    let minLng = Infinity;
    let maxLng = -Infinity;
    for (const [lat, lng] of coords) {
        if (lat < minLat) minLat = lat;
        if (lat > maxLat) maxLat = lat;
        if (lng < minLng) minLng = lng;
        if (lng > maxLng) maxLng = lng;
    }

    const midLat = (minLat + maxLat) / 2;
    const dLat = km / KM_PER_DEG_LAT;
    const dLng = km / (KM_PER_DEG_LAT * Math.max(Math.cos((midLat * Math.PI) / 180), 0.01));

    return [
        [minLat - dLat, minLng - dLng],
        [maxLat + dLat, maxLng + dLng],
    ];
}
